'use strict';
import React, { forwardRef, useRef, useEffect } from 'react';
import { sanitizeDomProps } from '../inc/domProps';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { runtime } from '../inc/Runtime';
import AppLink from './AppLink';

const FOOTER_COPY = {
	fr: {
		links: [
			{ text: 'Événementiel', to: '#h__services-events' },
			{ text: 'Vente & installation', to: '#h__services-installation' },
			{ text: 'Services aux écoles', to: '#h__school-service' }
		],
		tagline: 'Des systèmes conçus pour l\'excellence',
		copyright: 'S.A.V. Solutions Audiovisuelles',
		privacy: 'Politique de confidentialité',
		credit: 'Développement web par Studio Champ Gauche'
	},
	en: {
		links: [
			{ text: 'Events', to: '#h__services-events' },
			{ text: 'Sales & installation', to: '#h__services-installation' },
			{ text: 'School services', to: '#h__school-service' }
		],
		tagline: 'Systems designed for excellence',
		copyright: 'S.A.V. Audiovisual Solutions',
		privacy: 'Privacy Policy',
		credit: 'Web development by Studio Champ Gauche'
	}
};

const normalizeLangCode = lang => String(lang || '').trim().split(/[-_]/)[0].toLowerCase();

const getCurrentLang = route => {
	const htmlLang = typeof document !== 'undefined'
		? document.documentElement?.lang
		: '';
	const lang = [
		route?.lang,
		route?.language,
		route?.locale,
		htmlLang,
		runtime.site?.language,
		runtime.bootstrap?.site?.language,
		runtime.route?.lang,
		runtime.route?.language,
		runtime.route?.locale
	].map(normalizeLangCode).find(Boolean);

	return lang || 'fr';
};

const getFooterCopy = lang => FOOTER_COPY[normalizeLangCode(lang)] || FOOTER_COPY.fr;

const Footer = forwardRef(function Footer({ show = false, className = null, route = null, ...props }, ref){

	const localRef = useRef(null);
	const footerRef = ref || localRef;
	const content = getFooterCopy(getCurrentLang(route));

	if(!show){
		return null;
	}

	const tagProps = {
		className: className,
		...sanitizeDomProps(props)
	}

	useEffect(() => {

		gsap.to(footerRef.current, 1, {
			"--moveX": 0,
			"--scale": 1,
			"--opacity": 1,
			scrollTrigger: {
				trigger: footerRef.current,
				start: 'top bottom',
				end: 'bottom bottom',
				scrub: true
			}
		});

	}, []);

	return(
		<footer ref={footerRef} {...tagProps}>
			<div className="container">
				<div className="top">
					<div className="contents">
						<div className="inner-contents">
							<ul>
								{content.links.map(link => (
									<li key={link.text}>
										<AppLink to={link.to}>{link.text}</AppLink>
									</li>
								))}
							</ul>
							<span>{content.tagline}</span>
						</div>
					</div>
				</div>
				<div className="bottom">
					<span>{content.copyright} &copy; {new Date().getFullYear()}</span>
					<ul>
						<li>
							<AppLink to="#">{content.privacy}</AppLink>
						</li>
						<li>
							<AppLink to="https://champgauche.studio" target="_blank">{content.credit}</AppLink>
						</li>
					</ul>
				</div>
			</div>
		</footer>
	);

});

export default Footer;
